import { z } from 'zod';

import Timestamp from '../../../store/modules/models/global/Timestamp';

const dropdownOptionSchema = z.object({
  name: z.string(),
});

export const fieldSchema = z.object({
  id: z.number(),
  contract_id: z.number(),
  width: z.string(),
  height: z.string(),
  top: z.string(),
  left: z.string(),
  party_id: z.number(),
  merge_field: z.string(),
  type: z.string(),
  title: z.string(),
  font: z.string(),
  page: z.number(),
  required: z.boolean(),
  colour: z.string(),
  group: z.string(),
  content: z.string().nullable(),
  upload: z.string().nullable(),
  created_at: Timestamp,
  choices: z.array(dropdownOptionSchema),
  /**
   * This item in the collection will only be included for fields whose type
   * is "signature", and returns a boolean based on whether or not a signature
   * has been signed by either typing a signature (input_value_content),
   * drawn a signature (input_value_drawn_json) or uploaded a signature
   * (input_value_upload)
   *
   * In the future, each type may have its own specific resource or may extend
   * this item specifically per field.
   */
  is_completed: z.boolean().nullish(),
});

export const fieldsSchema = fieldSchema.array();
